/**
 * Created by andrey on 18.06.2024
 */

const SpriteFrame = function (bundleName, key, name) {
    VirtualResource.call(this, bundleName, key);

    if (name && name.fromSource) {
        this.fromSource = true;
        this.url = name.url;
    } else if (name) {
        this.name = name;
    }
};

SpriteFrame.prototype = Object.create(cc.VirtualResource.prototype);
SpriteFrame.prototype.constructor = SpriteFrame;

SpriteFrame.prototype.getTexture = function () {
    return this._texture;
};

SpriteFrame.prototype.getRect = function () {
    return this._rect;
};

SpriteFrame.prototype.isRotated = function () {
    return this._rotated;
};

SpriteFrame.prototype.getOffset = function () {
    return this._offset;
};

SpriteFrame.prototype.getOriginalSize = function () {
    return this._originalSize;
};

SpriteFrame.prototype.textureLoaded = function () {
    return this._textureLoaded;
};

SpriteFrame.prototype._rotateForCanvas = function () {
    if (cc._renderType === cc.game.RENDER_TYPE_CANVAS && this.isRotated()) {
        let tempElement = this.getTexture().getHtmlElementObj();
        const rectInPixels = cc.rectPointsToPixels(this._rect);
        tempElement = cc.Sprite.CanvasRenderCmd._cutRotateImageToCanvas(tempElement, rectInPixels, false);
        const tempTexture = new cc.Texture2D();
        tempTexture.initWithElement(tempElement);
        tempTexture.handleLoadedTexture();
        this._texture = tempTexture;
        this._rotated = false;

        this._rect.x = 0;
        this._rect.y = 0;
    }
};

SpriteFrame.prototype.setFrameData = function (data) {
    const texture = data.texture || cc.textureCache.getTextureForKey(bundles[this.bundleName].urls.png);

    this._textureLoaded = true;

    if (engine === "cocos2d") {
        this._texture = texture;
        this._rect = cc.rectPixelsToPoints(cc.rect(data.rect));
        this._rotated = data.rotated || false;
        this._originalSize = cc.size();
        this._offset = data.offset || cc.p();
        cc._sizePixelsToPointsOut(data.size || cc.size(), this._originalSize);

        this._rotateForCanvas();
    } else {
        this._texture = texture;
        this._rect = data.rect;
        this._originalSize = data.size;
        this._offset = data.offset;

        if (data.rotated) {
            this._rotated = true;
            this._flipUVX = true;
            this._flipUVY = true;
        }
    }
};

SpriteFrame.prototype.onUnload = function () {
    delete this._texture;
    delete this._textureLoaded;
    delete this._rect;
    delete this._rotated;
    delete this._originalSize;
    delete this._offset;
    delete this._spriteFrame;
};

SpriteFrame.prototype.save = function () {
    if (this.fromSource) {
        return { fromSource: true, url: this.url };
    }
    return this.name;
};

SpriteFrame.prototype.getUrl = function () {
    if (this.fromSource) {
        return this.url;
    }
};

if (engine === "cocos2d") {
    cc.SpriteFrame = SpriteFrame;
}

if (engine === "creator") {
    SpriteFrame.prototype.getSpriteFrame = function () {
        if (this._spriteFrame) {
            return this._spriteFrame;
        }

        this._spriteFrame = new cc.SpriteFrame();
        this._spriteFrame.texture = this._texture;
        this._spriteFrame.rect = this._rect;
        this._spriteFrame.originalSize = this._originalSize;
        this._spriteFrame.offset = this._offset;

        if (this._rotated) {
            this._spriteFrame.rotated = true;
            this._spriteFrame.flipUVX = true;
            this._spriteFrame.flipUVY = true;
        }

        return this._spriteFrame;
    };
}